const choices = {
    monthly: 'Mensuel',
    annual: 'Annuel',
};

export default choices;
